import React, { useState } from 'react'
import { Typography } from '@mui/material'
import { Filters } from '@vedmarket/ui-kit'
import { useTranslation } from 'react-i18next'
import ApplicationStatusIcon from '../status-icon'
import { getApplicationStatusLabel } from '../status-label'

import './filters.scss'

const ApplicationsFilters = ({ options, onApply, appliedStatus }: ApplicationFiltersProps) => {
  const { t } = useTranslation()

  const allStatuses = options.map((option) => option.value)
  const [ selectedStatuses, setSelectedStatuses ] = useState<string[]>(() => appliedStatus ? appliedStatus.split(',') : allStatuses)

  return (
    <Filters
      applyButtonText={t('actions__text__applyFilters')}
      onApply={(values) => {
        const statuses = (values.status as string[]) || []
        const isAllSelected = statuses.length === allStatuses.length

        onApply(isAllSelected ? '' : statuses.join(','))
      }}
      onChange={(values) => {
        setSelectedStatuses((values.status as string[]) || [])
      }}
      sections={[
        {
          key: 'status',
          title: t('applications__text__statusFilter'),
          defaultValues: allStatuses,
          selectedValues: selectedStatuses,
          options: options.map((option) => ({
            value: option.value,
            label: (
              <div className='applications-filters__option'>
                <ApplicationStatusIcon status={option.value} label={option.label} muted />
                <Typography variant='body1'>
                  {getApplicationStatusLabel({
                    status: option.value,
                    fallback: option.label,
                    translate: t,
                  })}
                </Typography>
              </div>
            ),
          })),
        },
      ]}
    />
  )
}

export default ApplicationsFilters
